export default __webpack_public_path__ + "static/media/Pattern5.54e3d245.png";